import useEventCallback from '../../utils/useEventCallback.mjs';
import useIsomorphicLayoutEffect from '../dom/useIsomorphicLayoutEffect.mjs';

function useResizeObserver(element, onResize) {
  const handleResize = useEventCallback(onResize);
  useIsomorphicLayoutEffect(() => {
    let rAF = 0;
    if (element) {
      const resizeObserver = new ResizeObserver(() => {
        cancelAnimationFrame(rAF);
        rAF = window.requestAnimationFrame(handleResize);
      });
      resizeObserver.observe(element);
      return () => {
        window.cancelAnimationFrame(rAF);
        resizeObserver.unobserve(element);
      };
    }
  }, [element, handleResize]);
}

export { useResizeObserver as default };
//# sourceMappingURL=useResizeObserver.mjs.map
